
export const isMobileDevice =() =>{
        return window.matchMedia("only screen and (max-width: 760px)").matches;
}

// export const isAcrobatReaderInstalled = () => {
//     var isInstalled = false;
//     if (window.ActiveXObject) {
//         var control = null;
//         try {
//             // AcroPDF.PDF is used by version 7 and later
//             control = new ActiveXObject('AcroPDF.PDF');
//         } catch (e) { }
//         if (!control) {
//             try {
//                 // PDF.PdfCtrl is used by version 6 and earlier
//                 control = new ActiveXObject('PDF.PdfCtrl');
//             } catch (e) { }
//         }
//         if (control)
//             isInstalled = true;
//     } else {
//         // Check navigator.plugins for "Adobe Acrobat" or "Adobe PDF Plug-in"*
//         for (var i = 0; i<navigator.plugins.length; i++) 
//         {   
//            var n = navigator.plugins[i].name;                              
//            if (n.indexOf('Adobe Acrobat') > -1 || n.indexOf('Adobe PDF') > -1 || 
//                n.indexOf('PDF Viewer') > -1 || n.indexOf('Flash') > -1)
//            {
//                 isInstalled = true; 
//                 break;
//            }
//         }
//     }   
//     return isInstalled;
// }

let name = null;
let plugin = null;

export var getBrowserName = function() {
    return name = name || function() {
        var userAgent = navigator ? navigator.userAgent.toLowerCase() : "other";

        if(userAgent.indexOf("edge") > -1){
            return "edge";
        } else if(userAgent.indexOf("chrome") > -1){
            return "chrome";
        } else if(userAgent.indexOf("safari") > -1){
            return "safari";
        } else if(userAgent.indexOf("msie") > -1 || navigator.appVersion.indexOf('Trident/') > 0){
            return "ie";
        } else if(userAgent.indexOf("firefox") > -1){
            return "firefox";
        } else {
            //return "ie";
            return userAgent;
        }
    }();
};

var getActiveXObject = function(name) {
    try { return new ActiveXObject(name); } catch(e) {}
};

var getPDFPlugin = function() {
    return plugin = plugin || function() {
        // load the activeX control
        // AcroPDF.PDF is used by version 7 and later
        // PDF.PdfCtrl is used by version 6 and earlier
        return getActiveXObject('AcroPDF.PDF') || getActiveXObject('PDF.PdfCtrl');
    }();
};

export var isAcrobatInstalled = function() {
    return !!getPDFPlugin();
};


